import AbstractClientStore from './AbstractClientStore';

const LOCAL_STORAGE_TOKEN_KEY = 'token';
const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'refresh_token';

class AuthClientStore extends AbstractClientStore {
  static getToken(): string | null {
    return this.storage.getItem(LOCAL_STORAGE_TOKEN_KEY);
  }

  static setToken(token: string): void {
    this.storage.setItem(LOCAL_STORAGE_TOKEN_KEY, token);
  }

  static removeToken(): void {
    this.storage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
  }

  static getRefreshToken(): string | null {
    return this.storage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY);
  }

  static setRefreshToken(token: string): void {
    this.storage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, token);
  }

  static removeRefreshToken(): void {
    this.storage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY);
  }
}

export default AuthClientStore;
